export const JUP_V4_PROGRAM_ID = 'JUP4Fb2cqiRUcaTHdrPC8h2gNsA2ETXiPDD33WcGuJB';
export const JUP_V6_PROGRAM_ID = 'JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4';
export const JUPITER_PERPS_PROGRAM_ID =
	'5BUwFW4nRbftYTDMbgxykoFWqWHPzahFSNAaaaJtVKsq';
